import { axiosInstance } from '@/plugins/axios';

// initial state
export const moduleState = {
  searchResults: [],
  isSearching: false,
  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalRecords: 0,
  },
  sortBy: '',
  includeCancel: false,
};

// getters
export const getters = {};

// mutations
export const mutations = {
  setSearchResults(state, value) {
    state.searchResults = value;
  },
  setIsSearching(state, value) {
    state.isSearching = value;
  },
  setPagination(state, value) {
    state.pagination = value;
  },
  setCurrentPage(state, newValue) {
    state.pagination.currentPage = newValue;
  },
  setPageSize(state, newValue) {
    state.pagination.pageSize = newValue;
  },
  setSortBy: (state, value) => {
    state.sortBy = value;
  },
  setIncludeCancel(state, newValue) {
    state.includeCancel = newValue;
  },
};

// actions
export const actions = {
  async searchForClient({ commit, state }, search = null) {
    try {
      commit('setIsSearching', true);

      const results = await axiosInstance.get(`/api/clients/search`, {
        params: {
          q: search,
          page: state.pagination.currentPage,
          pageSize: state.pagination.pageSize,
          sortBy: state.sortBy,
          includeCancel: state.includeCancel,
        },
      });

      const data = results.data;

      commit('setSearchResults', data.items);
      commit('setPagination', data.metaData);

      commit('setIsSearching', false);
      return data;
    } catch (error) {
      console.error(error);
      commit('setIsSearching', false);
    }
  },
};
